<!-- Uploader.vue -->

<!-- HTML Template -->
<template>
    <div class="self-uploader-container">
      <template v-if="showMedia">
        <div class="self-uploader-container__uploaded-photo-wrap">
          <template v-if="photoMedia">
            <img class="self-uploader-container__uploaded-photo-wrap__thumb" :src="getThumbnail(media.data)">
            <div class="photo-component__buttons">
              <div class="photo-component__buttons-container">
                <a @click="showGallery()" class="button button-m button-outline-white">{{ $t('common.change_photo') }}</a>
                <template v-if="allow_video">
                <a @click="addVideo()" class="button button-m button-outline-white photo-component__crop-button">{{ $t('common.add_video') }}</a>
                </template>
                <a @click="showCrop()" class="button button-m button-outline-white photo-component__crop-button">{{ $t('common.crop_and_resize') }}</a>
              </div>
            </div>
          </template>
          <template v-else-if="embeddedVideoMedia">
            <img class="self-uploader-container__uploaded-photo-wrap__thumb" :src="media.data.thumb_path" alt="">
            <img class="self-uploader-container__uploaded-photo-wrap__play"  :src="getPlayBtnSrc" alt="">
            <div class="photo-component__buttons">
              <div class="photo-component__buttons-container">
                <a @click="showGallery()" class="button button-m button-outline-white">{{ $t('common.select_photo') }}</a>
                <a @click="editVideo()" class="button button-m button-outline-white photo-component__crop-button">{{ $t('common.replace_video') }}</a>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="cursor-pointer w-100 h-100" @click.prevent="showGallery()">
          <div class="add-photo__text-container">
              <div class="add-photo__plus"><img src="/img/add.svg" alt=""></div>
              <p class="text-center subtitle text-secondary">
                {{ description }}
              </p>
          </div>
        </div>
      </template>
    </div>
</template>

<!-- Javascript -->
<script>
  const TYPE_PHOTO = 'photo';
  const TYPE_EMBEDDED_VIDEO = 'embedded_video';

  export default {
    props: {
        listing_id: Number,
        description: String,
        type: String,
        media: Object,
        gallery_title: {
            type: String,
            default: ""
        },
        allow_video: {
            type: Boolean,
            default: true
        },
        gallery_description: {
            type: String,
            default: ""
        },
    },
    data() {
        return {

        }
    },
    computed: {
      showMedia() {
        return this.media ? true : false;
      },
      photoMedia() {
        return this.media.type == TYPE_PHOTO ? true : false;
      },
      embeddedVideoMedia() {
        return this.media.type == TYPE_EMBEDDED_VIDEO ? true : false;
      },
      getPlayBtnSrc() {
        if (this.media.data.type == 'youtube') {
          return '/img/youtube-play.svg';
        } else {
          return '/img/vimeo-play.png';
        }
      }
    },
    methods: {
      showGallery() {
        this.$root.$emit('show_gallery', this.type, this.getPhotoId(), this.gallery_title, this.gallery_description)
      },
      showCrop() {
        this.$root.$emit('show_crop', this.type, this.media.data)
      },
      addVideo() {
        this.$root.$emit('show_add_video', this.type, 'add');
      },
      editVideo() {
        this.$root.$emit('show_add_video', this.type, 'edit');
      },
      getPhotoId() {
        return this.media ? this.media.data.id : false;
      },
      deletePhoto() {
        let url = `/api/photos/unset/${this.listing_id}`;
        return axios.patch(url, {
              type: this.type,
              id: this.media.data.id
            })
            // get data
            .then(function (response) {
                this.$root.$emit('unset_photo', this.type)
            }.bind(this));
      },
      getThumbnail(photo) {
        return photo.thumb_path ? photo.thumb_path : photo.full_path;
      },
    },
    mounted() {
    },
  }

</script>
